import { endpoints } from 'constants/endpoints';

import { sendRequest } from '../sendRequest';

export const getFiltersApi = () => {
  const url = endpoints.analytics.goal.filters;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

/**
 * @deprecated 06-08-2024
 */
export const getAggregatedScoreApi = ({ cohort, groupByKeys, splitByKeys, graphType, timeBounds }) => {
  const url = endpoints.analytics.goal.objective.aggregatedScore;
  const body = {
    groupByKeys,
    splitByKeys,
    graphType,
    timeBounds,
  };

  body.cohortId = cohort?.id;

  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body,
  });
};

export const getTimelineScoreApi = ({ parentUuid, cohort, groupByKeys, splitByKeys, timeBounds }) => {
  const url = endpoints.analytics.goal.objective.timeline;
  const body = {
    parentUuid,
    groupByKeys,
    splitByKeys,
    timeBounds,
  };

  body.cohortId = cohort?.id;

  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body,
  });
};

export const getTabularDataApi = ({
  selectedCohort = null,
  cohort,
  groupByKeys,
  splitByKeys,
  parentUuid,
  orderBy,
  timeBounds,
  attributeFilter,
  isExpandedViewRequired = false,
}) => {
  const shouldCallV1 = selectedCohort;
  // && groupByKeys?.keyName === 'employeeId';

  const url = shouldCallV1
    ? endpoints.analytics.goal.objective.tabularDataV1
    : endpoints.analytics.goal.objective.tabularData;

  const body = {
    groupByKeys,
    splitByKeys,
    parentUuid,
    orderBy,
    timeBounds,
    attributeFilter,
  };

  if (selectedCohort) {
    body.cohortId = selectedCohort?.id;
  } else {
    body.cohortId = cohort?.id;
  }

  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    queryParams: {
      isExpandedViewRequired,
    },
    body,
  });
};

export const getTopGoalsApi = ({ cohort, groupByKeys, splitByKeys, orderBy, limit, timeBounds }) => {
  const url = endpoints.analytics.goal.objective.topGoals;
  const body = {
    groupByKeys,
    splitByKeys,
    orderBy,
    timeBounds,
  };

  body.cohortId = cohort?.id;

  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    queryParams: {
      limit,
    },
    body,
  });
};

export const getObjectiveStatusApi = ({ parentUuid, cohort, groupByKeys, splitByKeys, timeBounds }) => {
  const url = endpoints.analytics.goal.objective.status;

  const body = {
    parentUuid,
    groupByKeys,
    splitByKeys,
    timeBounds,
  };

  body.cohortId = cohort?.id;

  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body,
  });
};

export const getCohortValues = ({ pageType, reviewId }) => {
  const url = endpoints.analytics.review.cohort.values;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      pageType,
      reviewCycleId: reviewId,
    },
  });
};

export const createCohort = ({ cohortName, query }) => {
  const url = endpoints.analytics.review.cohort.save;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      name: cohortName,
      query,
    },
  });
};

export const fetchGoalsApi = ({ limit, offset, cohort, groupByKeys, splitByKeys, parentUuid }) => {
  const url = endpoints.analytics.goal.objective.goals;

  const body = {
    groupByKeys,
    splitByKeys,
    parentUuid,
  };

  body.cohortId = cohort?.id;

  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    queryParams: {
      limit,
      offset,
    },
    body,
  });
};

/**
 * @deprecated 06-08-2024
 */
export const generateCSVDataApi = ({
  cohort,
  groupByKeys,
  source,
  filter,
  orderBy,
  timeBounds = null,
  selectedCohort,
}) => {
  const url = endpoints.analytics.goal.generateFile;
  const body = {
    groupByKeys,
    source,
    filter,
    orderBy,
    ...(timeBounds && { timeBounds }),
  };

  if (selectedCohort) {
    body.cohortId = selectedCohort?.id;
  } else {
    body.cohortId = cohort?.id;
  }

  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body,
  });
};

export const getCSVGenerationStatusApi = (requestIds) => {
  const url = endpoints.analytics.review.fileGenerationStatus;
  return sendRequest({
    url,
    credentials: 'include',
    queryParams: {
      requestIds,
    },
  });
};

export const downloadCSVApi = (requestId) => {
  const url = endpoints.analytics.review.downloadFile(requestId);
  return sendRequest({
    url,
    credentials: 'include',
  });
};

export const getGoalsInsightsGroupByIndividualDataApi = ({
  selectedCohort = null,
  groupByKeys,
  splitByKeys,
  orderBy,
  timeBounds,
}) => {
  const url = endpoints.analytics.goal.groupByIndividual;

  const body = {
    groupByKeys,
    splitByKeys,
    orderBy,
    timeBounds,
  };
  body.cohortId = selectedCohort?.id;

  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    queryParams: {
      isExpandedViewRequired: false,
    },
    body,
  });
};

/**
 * @deprecated 06-08-2024
 */
export const getGoalsInsightsGroupByIndividualDataOldApi = ({
  selectedCohort = null,
  groupByKeys,
  splitByKeys,
  orderBy,
  timeBounds,
}) => {
  const url = endpoints.analytics.goal.groupByIndividualOld;

  const body = {
    groupByKeys,
    splitByKeys,
    orderBy,
    timeBounds,
  };
  body.cohortId = selectedCohort?.id;

  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    queryParams: {
      isExpandedViewRequired: false,
    },
    body,
  });
};

export const getGoalsInsightsGroupByGoalsDataApi = ({
  cohort,
  groupByKeys,
  splitByKeys,
  orderBy,
  timeBounds,
  attributeFilter,
  isHierarchyView,
  pageType,
  isTreeView,
}) => {
  const url = endpoints.analytics.goal.groupByGoals;
  const body = {
    groupByKeys,
    splitByKeys,
    orderBy,
    timeBounds,
    attributeFilter,
  };

  body.cohortId = cohort?.id;
  if (cohort?.teamId) {
    body.teamId = cohort?.teamId;
  }

  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    queryParams: {
      isHierarchyView,
      pageType,
      isTreeView,
    },
    body,
  });
};
